import { FIXED_COLUMN_CATEGORY } from './Names';
import { Messages } from './Messages';

export class Validators {
   static minValue = (min: number, message = '') => (value: string) => {
      return value && value.length < min ? message : undefined;
   };

   static images = () => (_, values) => {
      if(!values.images?.length && !values.videos?.length) {
         return "Please upload at least one file"
      }

      if(values && values.images?.length > 10) {
         return  "Please choose less than 10 images"
      }

      if(values && values.images?.length && values.videos?.length) {
         return "Please choose only a video or images"
      }

      return undefined
   };

   static video = () => (_, values) => {
      console.log({values});
      if(!values.images?.length && !values.videos?.length) {
         return "Please upload at least one file"
      }

      if(values && values.videos?.length > 1) {
         return  "Please choose only 1 video"
      }

      if(values && values.videos?.length && values.images?.length) {
         return "Please choose only a video or images"
      }

      return undefined
   }
}
export const notHair = (value, allValues) => {
   if (value && value.trimLeft().trimRight() === FIXED_COLUMN_CATEGORY ) {
       return Messages.NOT_HAIR
   }
   return undefined;
};

export const trimValidation = (value, allValues) => {
   if (value && value.trimLeft().trimRight().length < 3 ) {
       return Messages.MIN_VALUE
   }
   return undefined;
};
